export const MAX_RECOMMENDED_WIDTH = 1920;
export const MIN_RECOMMENDED_WIDTH = 1280;
export const SCREEN_SIZE_MAX_PROMPTS = 3;
